/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorVideoReels as ResolvedLabradorVideoReels } from 'base/components/labrador/VideoReels';

export const LabradorVideoReels: typeof ResolvedLabradorVideoReels = withLabradorInstanceof((props) => {
    return <ResolvedLabradorVideoReels {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorVideoReelsProps = PropsFromComponent<typeof LabradorVideoReels>;
